<template>
  <div class="marketing-plane">
    <div class="page-index">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          label="定时计划"
          name="timePlan"
        >
          <time-plan></time-plan>
        </mk-tab-pane>
      </mk-tabs-biz>
    </div>
  </div>
</template>

<script>
import timePlan from './time-plan/index.vue'
export default {
  name: 'MarketingPlane',
  components: {
    timePlan
  },
  data () {
    return {
      activeName: 'timePlan'
    }
  }
}
</script>

<style lang='scss' scoped>
.marketing-plane {
  width: 100%;
  height: 100%;

  .page-index {
    height: 100%;

    .mk-tabs-biz {
      display: flex;
      flex-direction: column;
      height: 100%;

      & /deep/ .el-tabs__content {
        flex: 1;

        .el-tab-pane {
          flex: 1;
          height: 100%;
        }
      }
    }
  }

  .content {
    width: calc(100% - 32px);
    margin: 0 auto;
    height: 100%;
    box-sizing: border-box;
    padding-top: 16px;
  }
}
</style>
